// extracted by mini-css-extract-plugin
module.exports = {"page-title":"skeleton-header_page-title__gM5Es","showing":"skeleton-header_showing__26aAk","sort-by":"skeleton-header_sort-by__WPMXx"};